<template>
  <AppInput
    v-bind="$attrs"
    :theme="theme"
    :error="hideError ? '' : error"
    :custom-class="customClass"
    :error-position="errorPosition"
    v-on="$listeners"
    @input="handleInput"
  >
    <template
      v-if="$slots.countryBox"
      #countryBox
    >
      <div class="country-box">
        <img
          :src="require('@/assets/img/canadian-flag.png')"
          alt="Canadian Flag"
        >
        <span>+1</span>
      </div>
    </template>
  </AppInput>
</template>

<script>
import AppInput from '@/components/common/inputs/AppInput'
import navigation from '@/mixins/navigation'

export default {
  // Name
  name: 'AppInputWithValidation',

  // Components
  components: {
    AppInput
  },

  mixins: [
    navigation
  ],

  // Inherit Attrs
  inheritAttrs: false,

  // Props
  props: {
    fieldName: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'aggressive'
    },
    rules: {
      type: String,
      default: ''
    },
    hideError: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'green'
    },
    error: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    },
    errorPosition: {
      type: String,
      default: 'bottom' // 'top' or 'bottom'
    }
  },

  methods: {
    handleInput () {
      if (!this.hideError) this.$_navigation_validateStep()
    }
  }
}
</script>

<style scoped lang="scss">
</style>
